import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private activeSnackbars: MatSnackBarRef<TextOnlySnackBar>[] = [];

  constructor(private readonly _snackBar: MatSnackBar) { }

  openSnackBar(message: string, action?: string, options?: MatSnackBarConfig): MatSnackBarRef<TextOnlySnackBar> {
    // Ensure default duration is always applied if not explicitly set
    const defaultOptions: MatSnackBarConfig = {
      duration: 1000 * 3
    };

    const finalOptions = { ...defaultOptions, ...options };

    const snackBarRef = this._snackBar.open(message, action, finalOptions);

    // Track active snackbars
    this.activeSnackbars.push(snackBarRef);

    // Remove from tracking when dismissed
    snackBarRef.afterDismissed().subscribe(() => {
      const index = this.activeSnackbars.indexOf(snackBarRef);
      if (index > -1) {
        this.activeSnackbars.splice(index, 1);
      }
    });

    return snackBarRef;
  }

  /**
   * Dismiss all active snackbars
   */
  dismissAll(): void {
    this.activeSnackbars.forEach(snackBarRef => {
      try {
        snackBarRef.dismiss();
      } catch (error) {
        // Ignore errors when dismissing already dismissed snackbars
      }
    });
    this.activeSnackbars = [];
  }
}
